/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

import Button from "@mui/material/Button";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
} from "@mui/x-data-grid";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import { blue, red, yellow } from "@mui/material/colors";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Axios from "axios";
import { ToastContainer, toast, Zoom } from "react-toastify";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../src/store/userSilce";
import { useDispatch } from "react-redux";

require("moment/locale/th");

const theme = createTheme({
  palette: {
    primary: {
      main: red[500],
    },
    secondary: {
      main: yellow[500],
    },
    third: {
      main: blue[800],
    },
  },
});

function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
      }}
    >
      <GridToolbarQuickFilter
        quickFilterParser={(searchInput) =>
          searchInput
            .split(",")
            .map((value) => value.trim())
            .filter((value) => value !== "")
        }
      />
    </Box>
  );
}

function ContentListScores({ history }) {
  const [data, setData] = useState("");
  const location = useLocation();

  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const token = user.token;
  const [alerts, setAlerts] = useState(false);
  const [mission, setMission] = useState([]);
  const [selectMission, setselectMission] = useState("");
  const [selectAllList, setSelectAllList] = useState([]);
  const [loading, setLoading] = useState(true);
  const selectMissions =
    selectMission === "ศึกษาหลักสูตร วทอ.ยศ.ทอ."
      ? "SCC1"
      : selectMission === "ศึกษาหลักสูตร รร.สธ.ทอ.ยศ.ทอ."
      ? "SCC2"
      : selectMission === "ศึกษาหลักสูตร รร.นอส.ยศ.ทอ."
      ? "SCC3"
      : selectMission === "ศึกษาหลักสูตร รร.นฝ.ยศ.ทอ."
      ? "SCC4"
      : selectMission === "ราชการต่างประเทศกรณีอื่นๆ"
      ? "SCC5"
      : selectMission === "ศึกษาในต่างประเทศ"
      ? "SCC6"
      : selectMission === "ปฏิบัติงานในต่างประเทศ"
      ? "SCC7"
      : selectMission === "ทดสอบภาษาอังกฤษประจำปี"
      ? "SCC8"
      : "";

  const handleSelectChange = (e) => {
    setselectMission(e.target.value);
    setLoading(true);

    // Simulate a loading delay
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  const dispatch = useDispatch();

  const resultMap = new Map();

  selectAllList.forEach((item) => {
    const testresvcode = item.testresvcode;
    if (!resultMap.has(testresvcode)) {
      resultMap.set(testresvcode, item);
    }
  });

  const uniqueData = [...resultMap.values()];

  useEffect(() => {
    if (selectMissions === "") {
      toast.error("กรุณาเลือกภารกิจ");
    } else {
      var config = {
        method: "GET",
        url:
          process.env.REACT_APP_API_URL +
          `/getalldataTestscoresall/${selectMissions}`,
        headers: {
          authtoken: "bearer " + token,
        },
      };

      Axios(config)
        .then((res) => {
          setSelectAllList(res.data);
          setLoading(false); // เมื่อโหลดข้อมูลเสร็จให้เปลี่ยนสถานะ
        })
        .catch((err) => {
          if (err.response.status === 401) {
            dispatch(logout());
            navigate("/notfound404", {
              state: {
                statusCode: err.response.status,
                txt: err.response.data,
              },
            });
          } else if (err.response.status === 404) {
            dispatch(logout());
            navigate("/notfound404", {
              state: {
                statusCode: err.response.status,
                txt: err.response.data,
              },
            });
          }
          console.log("getPubrelContents: ", err);
        });
    }
  }, [selectMissions]);

  useEffect(() => {
    var config = {
      method: "GET",
      url: process.env.REACT_APP_API_URL + `/getTbtestscoringcriteria`,
      headers: {
        authtoken: "bearer " + token,
      },
    };

    Axios(config)
      .then((res) => {
        setMission(res?.data?.filter((_, index) => index !== 0));
        // console.log("data :", res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        } else if (err.response.status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        }
        console.log("getPubrelContents: ", err);
      });
  }, []);

  const columns = [
    {
      field: "id",
      headerName: "ลำดับ",
      width: 50,
      valueGetter: (params) =>
        params.api.getRowIndex(params.row.testresultcode) + 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "tbtestreservation.testrequnit",
      headerName: "หน่วยงาน",
      width: 200,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "tbtestreservation.testappvcode",
      headerName: "รหัสการทดสอบ",
      width: 220,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "testresvcode",
      headerName: "รหัสการจอง",
      width: 220,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "tbtestreservation.testreqdate",
      headerName: "วันที่จอง",
      width: 220,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {moment(params.value).add(543, "year").format("ll")}
          </div>
        );
      },
    },
    {
      field: "tbtestreservation.testreqtime",
      headerName: "เวลาที่จอง",
      width: 220,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "management",
      headerName: "การจัดการ",
      width: 220,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <strong>
          <ThemeProvider theme={theme}>
            <Link
              to="/ContentPageListTestScores"
              state={{
                testresultcode: params.row["testresultcode"],
                testresvcode: params.row.testresvcode,
                testreqdate: params.row["tbtestreservation.testreqdate"],
                testreqtime: params.row["tbtestreservation.testreqtime"],
                testscoringcriteria:
                  params.row["tbtestreservation.testscoringcriteria"],
                selectAllListsss: selectAllList,
                selectMissionss: selectMission,
              }}
              style={{ textDecoration: "none" }}
            >
              <Button
                variant="outlined"
                color="third"
                size="small"
                style={{ marginLeft: 16 }}
              >
                เข้าดูรายชื่อ
              </Button>
            </Link>

            {params.row.testresultapprv === null ? (
              <FiberNewIcon className="New_Tag"></FiberNewIcon>
            ) : (
              ""
            )}
          </ThemeProvider>
        </strong>
      ),
    },
  ];

  return (
    <>
      {alerts ? (
        <ToastContainer draggable={false} transition={Zoom} autoClose={3000} />
      ) : (
        <></>
      )}

      <br></br>
      <Typography component="div">
        <Box sx={{ textAlign: "center", fontSize: 35, fontWeight: 500 }}>
          <b>ข้อมูลผลคะแนนการทดสอบ</b>
        </Box>
      </Typography>
      <Typography component="div">
        <Box sx={{ textAlign: "center", fontSize: 16, fontWeight: 500 }}>
          ดูผลคะแนนตามรายการทดสอบ
        </Box>
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box sx={{ margin: "10px" }}>
          <FormControl sx={{ minWidth: 180 }}>
            <InputLabel id="demo-simple-select-label">
              ชื่อรายการทดสอบ
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="ชื่อรายการทดสอบ"
              onChange={handleSelectChange}
              // onChange={(e) => setselectMission(e.target.value)}
            >
              {mission.map((missions) => (
                <MenuItem value={missions.mission} key={missions.mission}>
                  {missions.mission}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <br />
      <Link to="/PageTestScores" style={{ textDecoration: "none" }}>
        <Button variant="outlined" startIcon={<ArrowBackIcon />}>
          ย้อนกลับ
        </Button>
      </Link>
      <div style={{ height: 400, width: "100%" }}>
        {selectMission === "" ? (
          <Box sx={{ textAlign: "center" }}>
            <p>กรุณาเลือกรายการทดสอบ</p>
          </Box>
        ) : loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <DataGrid
            getRowId={(row) => row.testresultcode}
            rows={uniqueData}
            localeText={{
              noRowsLabel: "ไม่มีข้อมูล",
            }}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: QuickSearchToolbar }}
          />
        )}
      </div>
    </>
  );
}

export default ContentListScores;
